import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-equipment-show',
  templateUrl: './equipment-show.component.html',
  styleUrls: ['./equipment-show.component.scss']
})
export class EquipmentShowComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
